module.exports = __webpack_public_path__ + "img/model-5.de2fb578.svg";